import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Row} from "react-bootstrap";
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { isNaturalNumber } from '../utils/jsUtils';
import { translateAPIError } from '../utils/apiUtils';


const LocationAdmin_NewLocationView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [locationAttrs, setLocationAttrs] = useState({
    id: '',
    code: '',
    description: '',
    site: '',
    building: '',
    wing: '',
    floor: '',
    room: '',
    roomType: '',
    roomSeq: null,
    externalSystemId: ''
  });

  const typeList = [
    { key: "CITY",     value: "CITY"     },
    { key: "DISTRICT", value: "DISTRICT" },
    { key: "SITE",     value: "SITE"     },
    { key: "BUILDING", value: "BUILDING" },
    { key: "WING",     value: "WING"     },
    { key: "FLOOR",    value: "FLOOR"    },
    { key: "ROOM",     value: "ROOM"     },
    { key: "LIFT",     value: "LIFT"     },
    { key: "OTHER",    value: "OTHER"    }
  ];

  // UI Functions

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setLocationAttrs({ ...locationAttrs, [e.target.name]: e.target.value })
  }

  const onTypeSelect = (key, event) => {
    setLocationAttrs({ ...locationAttrs, type: key })
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!locationAttrs.code || locationAttrs.code.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_loc_code"));
    } else if (locationAttrs.code.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_code") + "50");
    } else {
      validateOtherFields();
    }

    return;
  }

  function validateOtherFields() {
    // Validate form inputs

    if (!locationAttrs.description || locationAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
    } else if (locationAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + "200");

    } else if (!locationAttrs.type || locationAttrs.description.type === 0) {
      setErrMsg(t("I18N_ERR_Need_type"));

    } else if (locationAttrs.site && (locationAttrs.site.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_site") + "30");

    } else if (locationAttrs.building && (locationAttrs.building.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_building") + "30");

    } else if (locationAttrs.wing && (locationAttrs.wing.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_wing") + "30");

    } else if (locationAttrs.floor && (locationAttrs.floor.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_floor") + "30");

    } else if (locationAttrs.room && (locationAttrs.room.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_room") + "30");

    } else if (locationAttrs.roomType && (locationAttrs.roomType.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_room_type") + "30");

    } else if (locationAttrs.roomSeq && (locationAttrs.roomSeq.length > 0) &&
               (!isNaturalNumber(locationAttrs.roomSeq) || (locationAttrs.roomSeq > 2147483647))) {
      setErrMsg(t("I18N_Room_seq") + t("I18N_ERR_Must_be_pos_int_and_LT") + '2,147,483,648.');
      return;

    } else if (locationAttrs.externalSystemId && (locationAttrs.externalSystemId.length > 30)) {
      setErrMsg(t("I18N_ERR_Max_len_ext_sys_id") + "30");

    } else {
      createNewLocation();
    }
  }

  const createNewLocation = () => {

    // Extract room type and room sequence from the location code

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(locationAttrs));

    // Convert roomSeq into integer type
    reqBody.roomSeq = locationAttrs.roomSeq && (locationAttrs.roomSeq.length > 0) ? (locationAttrs.roomSeq * 1.0) : null;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("locations", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Location")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Location_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col>{t("I18N_Code")}: *</Col>
              <Col>{t("I18N_Description")}: *</Col>
              <Col>{t("I18N_Type")}: *</Col>
              <Col>{t("I18N_Ext_sys_id")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <input className={classes.admin_pages__field_editable} name="code" value={locationAttrs.code}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={locationAttrs.description}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
                <Col>
                  <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                    title={!locationAttrs.type ? t("common:I18N_DROPDOWN_PROMPT") : t("common:I18N_" + locationAttrs.type) }
                    onSelect={onTypeSelect}>
                    {typeList.map((item, index) => {
                      return (
                        <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                          {t("common:I18N_" + item.value)}
                        </Dropdown.Item>
                      );
                    })}
                  </DropdownButton>
                </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="externalSystemId" value={locationAttrs.externalSystemId}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col>{t("I18N_Site")}:</Col>
              <Col>{t("I18N_Building")}:</Col>
              <Col>{t("I18N_Wing")}:</Col>
              <Col>{t("I18N_Floor")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <input className={classes.admin_pages__field_editable} name="site" value={locationAttrs.site}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="building" value={locationAttrs.building}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="wing" value={locationAttrs.wing}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="floor" value={locationAttrs.floor}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col>{t("I18N_Room")}:</Col>
              <Col>{t("I18N_Room_type")}:</Col>
              <Col>{t("I18N_Room_seq")}:</Col>
              <Col></Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <input className={classes.admin_pages__field_editable} name="room" value={locationAttrs.room}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="roomType" value={locationAttrs.roomType}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} name="roomSeq" value={locationAttrs.roomSeq}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col></Col>
            </Row>

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>

      </Card>
    </>
  );
}
 
export default LocationAdmin_NewLocationView;
